<div class="org-cell">
  <ra-ui-radio-button [items]="radioButton" [value]="value" (click)="clicked()"></ra-ui-radio-button>
  <div class="org-name-desc">
    <div class="body-2">{{ organizationDesc }}</div>
  </div>
</div>
